import React from 'react';
import propTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import Typography from './Typography';
import validate from '../utils/label-validator';
import defaultPropValues from '../helper/defaultPropValues';
import './Text.scss';

const Text = (props) => {
	const data = { ...defaultPropValues.textProps.data, ...props.data };
	const { title, body, footer } = data;
	const labels = useLabels();

	return (
		<div className="ws-content-rows-text m-6 mx-sm-0">
			{validate(title) && (
				<Typography className="mb-5 mt-0" weight="normal" variant="h2">
					{labels.getHTML(title)}
				</Typography>
			)}
			{validate(body) && (
				<Typography variant="p">{labels.getHTML(body)}</Typography>
			)}
			{validate(footer) && (
				<Typography variant="p">{labels.getHTML(footer)}</Typography>
			)}
		</div>
	);
};

export const TextProps = {
	data: propTypes.shape({
		title: propTypes.string,
		body: propTypes.string,
		footer: propTypes.string,
		classes: propTypes.string,
		styles: propTypes.shape({})
	}).isRequired
};
Text.propTypes = TextProps;

export default Text;
